import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';

interface DynamicResultTableProps {
  data: any;
}

const DynamicResultTable: React.FC<DynamicResultTableProps> = ({ data }) => {
  if (!data) return null;

  const displayData = data.Data ? data.Data : data;

  const dataArray = Array.isArray(displayData) ? displayData : [displayData];

  if (dataArray.length === 0) {
    return <div className="alert alert-info mt-3">Nenhum resultado encontrado.</div>;
  }

  const headers = Object.keys(dataArray[0]);

  return (
    <div className="table-responsive mt-4">
      <table className="table table-bordered table-striped table-hover">
        <thead className="table-light">
          <tr>
            {headers.map(header => <th key={header}>{header}</th>)}
          </tr>
        </thead>
        <tbody>
          {dataArray.map((row, index) => (
            <tr key={index}>
              {headers.map(header => (
                <td key={`${header}-${index}`}>
                  {typeof row[header] === 'object' && row[header] !== null
                    ? JSON.stringify(row[header])
                    : String(row[header])}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DynamicResultTable;